module.exports = __webpack_public_path__ + "static/assets/ff2e90ea2a76230936ecef113c92f097.svg";